module.exports = __webpack_public_path__ + "img/live_more_1.7b40a9d9.png";